export default class DtoMaterielType {
    constructor(obj = {}) {
        this.field = obj.field
        this.code = obj.code
        this.label = obj.label
        this.startDate = obj.startDate
        this.endDate = obj.endDate
    }
}
